// Test IDs for configuration details components

export const CONFIGURATION_DETAILS_TEST_IDS = {
  CONTAINER: 'configuration-details-container',
  IDLE: 'configuration-details-idle',
  ERROR: 'configuration-details-error',
  FABRIC_GROUP: 'configuration-details-fabric-group',
  SIZE_PASSPORT_GROUP: 'configuration-details-size-passport-group',
  OPTIONS_GROUP: 'configuration-details-options-group',
  MONOGRAMS_GROUP: 'configuration-details-monograms-group',
  DETAIL_BUTTON: 'configuration-details-detail-button',
} as const;
